/**
 * author: Soumya Shreyas
 */

import moment from "moment";
import Multiselect from "multiselect-react-dropdown";
import React, { useContext, useEffect, useState } from "react";
import { Accordion, Button, Form, Modal } from "react-bootstrap";
import "react-dropdown-tree-select/dist/styles.css";
import { BsX } from "react-icons/bs";
import { ReactMultiEmailInput } from "react-multi-email-input";
import "react-multi-email-input/dist/style.css";
import { matchPath, useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  AssessmentShareTokenContext,
  GlbFormContext
} from "../../App";
import FormService from "../../core/services/FormService";
import Utils from "../../core/utilities/Utils";
function ShareFormModal({ data, type, modalShow, callbackModal }) {
  let { paramObj } = useParams();
  const location = useLocation();
  if (!paramObj && paramObj === undefined) {
    const match = matchPath({ path: "/form_builder/form_submit/:paramObj" }, location.pathname);
    paramObj = match?.params?.paramObj;
  }
  const { shareToken, setShareToken } = useContext(AssessmentShareTokenContext);
  const [show, setShow] = useState(modalShow);
  const [selSections, setSelSections] = useState([]);
  const [validated, setValidated] = useState(false);
  const { glbForm, setGlbForm } = useContext(GlbFormContext);
  const [emails, setEmails] = useState([]);
  const [sections, setSections] = useState([]);
  const [formData, setFormData] = useState([]);
  const [sharedSections, setSharedSections] = useState([]);
  const isOpenForm = location?.pathname?.indexOf('open-form') >= 0 ? true : false;

  let arr = [];
  useEffect(() => {
    let sections = glbForm?.sections;
    if (type === "form") {
      generateData(sections);
    } else {
      let id = {
        id: data.id,
      };
      setSelSections([id]);
    }
    getSharedWithDetails();
  }, [type]);
  const generateData = (sections) => {
    for (let i = 0; i < sections.length; i++) {
      let children = {
        label: sections[i].title,
        value: sections[i].id,
      };
      arr.push(children);
      if (sections[i].subSections.length > 0) {
        generateData(sections[i].subSections);
      }
    }
    setFormData(...formData, arr);
  };
  const handleClose = () => {
    setShow(false);
    callbackModal(false);
  };
  const shareForm = () => {
    if (emails.length > 0 && selSections.length > 0) {
      let param = {
        emails: emails,
        sections: selSections,
      };
      FormService.shareForm(glbForm.id, getTokenForAPICall(), param, isOpenForm)
        .then((response) => {
          if (response.status === 200) {
            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT,
            });
            callbackModal(false);
          }
        })
        .catch((error) => {
          let errormsg = error.response.data.message
            ? error.response.data.message
            : error.message;
          toast.error(errormsg, {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    }
    setValidated(true);
  };
  const onSelectRemove = (selectedList, selectedItem) => {
    let objArr = [];
    for (let i = 0; i < selectedList.length; i++) {
      var objId = {
        id: parseInt(selectedList[i].value),
      };
      objArr.push(objId);
    }
    setSelSections(objArr);
  };

  const getTokenForAPICall = () => {
    if (isOpenForm) {
      const match = matchPath({ path: '/form_builder/open-form/submit/:token' }, location.pathname);
      return match?.params?.token ?? '';
    }
    const decodedData = paramObj ? Utils.decodeBase64(paramObj) : "";
    const obj = decodedData ? JSON.parse(decodedData) : "";
    return paramObj ? obj?.key : shareToken;
  };

  const getSharedWithDetails = () => {
    
    FormService.sharedWithDetails(glbForm.id, getTokenForAPICall(), isOpenForm)
      .then((response) => {
        if (!response.status === 200) return;

        const sharedSections = [];
        response.data[0]?.shareDetails?.forEach(sd => {
          sd?.sections?.forEach(section => {
            const existingSection = sharedSections.find(s => s.id === section.id);
            if (existingSection) {
              if (existingSection.emails?.find(e => e.email === sd.email)) return;

              existingSection.emails.push(sd.email);
            } else {
              sharedSections.push({
                id: section.id,
                title: section.title,
                emails: [{ createdDate: sd.createdDate, email: sd.email }]
              });
            }
          });
        });
        setSharedSections(sharedSections);
      })
      .catch((error) => {
        let errormsg = error.response?.data?.message
          ? error.response.data.message
          : error.message;
        toast.error(errormsg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title className="h5">Share Assessment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate validated={validated}>
          <Form.Group className="mb-3">
            <Form.Label>Share Form/Section/Subsection</Form.Label>
            {type === "form" ? (
              <Multiselect
                options={formData} // Options to display in the dropdown
                selectedValues={sections} // Preselected value to persist in dropdown
                onSelect={onSelectRemove} // Function will trigger on select event
                onRemove={onSelectRemove} // Function will trigger on remove event
                displayValue="label" // Property name to display in the dropdown options
                showCheckbox
                required
              />
            ) : (
              <Form.Control
                type="text"
                name="section"
                value={data.title}
                disabled
              />
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Send to</Form.Label>
            <ReactMultiEmailInput
              placeholder="Email"
              emails={emails}
              setEmails={setEmails}
            />
          </Form.Group>


          <div className="Shared_listBox">
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>Shared List</Accordion.Header>
                <Accordion.Body className="p-0">
                  {
                    sharedSections?.map((section, index) => {
                      return (<div className="shared_data_box p-2">
                        <div className="shared_data_box_head mb-2">
                          Section {index + 1}
                        </div>
                        <div className="ps-2">
                          <h6>Shared with {section.emails?.length ?? 0}</h6>
                          <ul>
                            {
                              section.emails?.map(e => {
                                return (
                                  <li>{e.email}
                                    <small className="ms-2">[{moment(e.createdDate).format("DD-MM-YYYY")}]</small>
                                    <span><BsX /></span>
                                  </li>
                                )
                              })
                            }
                          </ul>
                        </div>
                      </div>)
                    })
                  }
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>          
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} autoFocus>
          Cancel
        </Button>
        <Button variant="primary" onClick={shareForm} className="sbmBtn">
          Share
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ShareFormModal;
